import { useMutation, useQueryClient } from 'react-query';
import { subscriptionService } from 'services';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useUpdateSubscriptionAddress = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ({
      subscriptionId,
      billAddressId,
      shipAddressId,
    }: {
      subscriptionId: number;
      billAddressId: number;
      shipAddressId: number;
    }) => {
      return subscriptionService.updateSubscriptionAddress(
        subscriptionId,
        shipAddressId,
        billAddressId
      );
    },
    {
      onSuccess: (data, variables, context) => {
        displayNotification(i18n['Subscription address successfully updated.']);
        queryClient.invalidateQueries([
          ServerStateKeysEnum.subscriptionHistory,
        ]);
      },
      onError: () => {
        displayNotification(
          i18n['Failed to update subscription billing address!'],
          'danger'
        );
      },
    }
  );
};
